import React, { Fragment } from "react";
import styled from "styled-components";

import Contact from "../components/Contact";

const Wrapper = styled.div`
	padding-left: 30px;

	@media (max-width: 576px) {
		padding-left: 0;
	}
`;

const Category = styled.h4`
	margin: 0;
	font-family: "Cera Basic";
	font-size: 1.3em;
	font-weight: bold;
	color: #d7761d;

	@media (max-width: 576px) {
		text-align: center;
	}
`;

const FlexWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 30px;
	margin-bottom: 40px;

	@media (max-width: 576px) {
		flex-direction: column;
		padding: 10px;
		text-align: center;
	}

	p,
	a {
		font-family: "Open Sans";
	}
`;

const StyledContact = styled(Contact)`
	flex: 0 1 30%;
`;

const Description = styled.p`
	flex: 0 1 60%;
`;

const ItemCollection = ({ category, items }) => (
	<Fragment>
		<h4 className="TGh6">{category}</h4>
		<FlexWrapper>
			{items.map((item) => (
				<StyledContact url={item.website_url} {...item} />
			))}
		</FlexWrapper>
	</Fragment>
);

const PointsOfInterest = ({ restaurants, lodgings, attractions }) => (
	<Wrapper>
		{!!restaurants.length && (
			<ItemCollection category="Restaurants" items={restaurants} />
		)}
		{!!lodgings.length && (
			<ItemCollection category="Lodging" items={lodgings} />
		)}
		{!!attractions.length && (
			<Fragment>
				<h4 className="TGh6">Must-sees Nearby</h4>
				{attractions.map((item) => (
					<FlexWrapper>
						<StyledContact url={item.website_url} {...item} />
						<Description>{item.description}</Description>
					</FlexWrapper>
				))}
			</Fragment>
		)}
	</Wrapper>
);

export default PointsOfInterest;
